import CNAComponent from '../Pages/Features/CNAcomponent';

const FeaturesComponent = () => {
    return (
        <article className="docs-article" id="section-6">
            <header className="docs-header">
                <h1 className="docs-heading">Features<span className="docs-time">Last updated: 2024-10-25</span>
                </h1>
            </header>
            <CNAComponent />
        </article>
    );
};

export default FeaturesComponent;